import React from 'react';
import TableHeader from 'components/table/TableHeader';
import TableRow from 'components/table/TableRow';
import TableCell from 'components/table/TableCell';
import Table from 'components/table/Table';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch, RootState} from '../../../store/store';
import {setActiveTab} from '../clientSlice';

interface VisibleColumnsType {
  id: boolean;
}

const ClientNotesTable: React.FC<{openDrawer: () => void; clientId?: string}> = ({openDrawer, clientId}) => {
  const dispatch = useDispatch<AppDispatch>();
  const activeTab = useSelector((state: RootState) => state.client.activeTab);
  const loading = false; // Placeholder - no loading needed

  const [visibleColumns, setVisibleColumns] = React.useState<VisibleColumnsType>({
    id: true,
  });

  const columnOptions = [
    {value: 'id', label: 'ID', isVisible: visibleColumns.id},
  ];

  const searchByOptions = [
    {
      value: 'id',
      label: 'ID',
    },
  ];

  const fetchData = async ({
    page, search, sortField, sortDirection, rowsPerPage,
  }: {
    page: number;
    search: any;
    sortField: string;
    sortDirection: string;
    rowsPerPage: number;
  }): Promise<void> => {
    // Placeholder - no data fetching needed
    console.log('ClientNotesTable fetchData called - placeholder');
  };

  const handleColumnToggle = (column: string) => {
    if (column in visibleColumns) {
      setVisibleColumns(prev => ({
        ...prev,
        [column]: !prev[column as keyof VisibleColumnsType],
      }));
    }
  };

  return (
    <Table
      fetchData={fetchData}
      pagy={{count: 0, pages: 0}}
      activeTab={activeTab}
      setActiveTab={(tab: string) => dispatch(setActiveTab(tab))}
      tabs={['Visits', 'Documents', 'Notes']}
      pageable={false}
      recordsName={'Notes'}
      searchable={false}
      columns={true}
      loading={loading}
      columnOptions={columnOptions}
      onColumnToggle={handleColumnToggle}
      searchByOptions={searchByOptions}
      blueButton={null}>
      <thead>
        <tr>
          {visibleColumns.id && <TableHeader label="ID" sortBy="id" />}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 dark:divide-neutral-700">
        <TableRow>
          <TableCell>
            <div className="text-center py-8 text-gray-500">
              No notes available yet
            </div>
          </TableCell>
        </TableRow>
      </tbody>
    </Table>
  );
};

export default ClientNotesTable;
